// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3pSc3","productName":"Table_productName__HHkHV"};